export const faqsOptions = [
    {
        question: 'Do I have to change settings on profile for every ride?',
        answer: 'No, the system has a log of most recent offering either for the ride provider or rider.',
    },
    {
        question: 'How to report an accident, safety incident or citation?',
        answer: 'If you experience an accident, an issue which threatens your personal safety, or receive a citation, make sure to take the appropriate steps to protect yourself and get to a safe place.',
    },
    {
        question: 'Can I get refunds for incomplete or unavailable ride provider?',
        answer: 'Yes all fees charged shall be refunded in case of eventualities leading to non-completion of the trip. Note, it may take a few days for refunds to reflect on bank account, this is solely dependent on the rider’s bank.',
    },
    {
        question: 'What if I wish to travel with corporate employees only?',
        answer: 'Parizzo is actually designed to make commuting safe, convenient and affordable for working professionals as they make their daily trips to work.',
    },
    {
        question: 'I lost something on board. What do I do?',
        answer: 'Send SMS or Whatsapp message to our customer support line at +234(0)816-000-0378, or email us at care@parizzo.com and we will do our best to help.',
    },
    {
        question: 'Can I request for two seats at once?',
        answer: 'Absolutely yes, but each request must be sent and processed individually.',
    },
    {
        question: 'I was supposed to offer a ride home today, but now I have an unplanned meeting to attend. What do I do?',
        answer: 'In this case, the planned trip must be cancelled early (at least one hour before the ride) to allow riders originally assigned to you book another trip with the app.',
    },
    {
        question: 'Can I trust Parizzo platform with my personal or credit card details?',
        answer: 'Yes, Parizzo does not store any card details within its facilities. The attached payment gateway handles all financial details transmitted through our platform',
    },
    {
        question: 'I leave office at different times every day, can I still use Parizzo?',
        answer: 'Yes, Parizzo is flexible, you can always search for a ride provider few minutes to when you are ready to leave, someone might be going your way. However, it is best to schedule your ride early enough so as to be sure of being matched with available ride providers especially during peak periods.',
    },
    {
        question: 'How can I report an accident case?',
        answer: 'Send us a mail at customercare@parizzo.com, through social media or whatsapp (08160000378). We will get back to you as soon as possible after you request the call.',
    },
    {
        question: 'Can I provide feedback and/or a rating for provider/ rider with whom I have shared a ride?',
        answer: 'Yes. It is required to provide feedback after every ride. Honest feedback helps improve service provided and give us guidance on how to serve you better.',
    },
    {
        question: 'How can I report abuse against fellow riders?',
        answer: 'Call our line at 08160000378, email us at customercare@parizzo.com. And we will take it up from there.',
    },
    {
        question: 'Is the system safe for female ride providers/riders?',
        answer: 'Yes. Parizzo does not discriminate on gender or any other grounds.',
    },
    {
        question: 'How does it work',
        answer: 'Parizzo connects riders with a ride provider close to each other and making a trip along similar route about the same time. Once both parties agree to make the trip together, the rider’s registered card gets charged while the provider’s bank account is credited instantly upon trip completion. No pranks, no payment related arguments and most importantly no card detail is stored on our platform to ensure maximum security.',
    },
    {
        question: 'I have unplanned appointments that came up when I have offered a ride. What do I do?',
        answer: 'Parizzo understands that that situations might arise to prevent you from honouring the trip as scheduled, it is therefore important you cancel such request/offering for a stipulate time. A new request/offering can be made when you are available to make your trip.',
    },
    {
        question: 'What if I shared a ride with someone once and do not wish to travel with him/her again?',
        answer: 'We understand and respect users’ preference. All you need to do is follow the guidelines provided in order to make your ridesharing experience convenient and comfortable.',
    },
    {
        question: 'How much do I pay and when?',
        answer: 'The cost of each trip is dependent on the distance travelled and payment is due on confirmation of the trip by the rider. Riders will see the amount due for a trip once a request is made. Riders will be charged immediately they are matched with a ride provider and consent to take the ride.',
    },
    {
        question: 'Is my data secured?',
        answer: 'Kutty A10 Limited privacy policy ensures that all data provided to the platform are handled with the highest level of responsibility to ensure your data privacy. Read our privacy policy  for more information.',
    },
    {
        question: 'What is the payment mechanism in the system?',
        answer: 'Payment on Parizzo is strictly by debit/credit card set up with the rider’s account, no cash payment will be accepted by ride providers during or after any trip.',
    },
    {
        question: 'Is the system secured?',
        answer: 'Our users registration and ride provider verification process ensures availability of information to identify everyone on every ride. This will ensure that you are not taking rides that can not be traced.',
    },
    {
        question: 'Does the system works on every mobile phone operating system?',
        answer: 'Only Android and iOS (iPhone) are supported at the moment.',
    },
    {
        question: 'What is Parizzo?',
        answer: 'Parizzo App connects private car owners (a.k.a. Ride Providers) driving to work with empty seats to people (Riders) that don’t want to drive but with similar trip direction.',
    },
]